import React from 'react';
import './StatusChip.scss';

export const statusConfig = [
  { label: "Pending", value: "pending", color: "#EEEB1E" },
  { label: "Submitted", value: "submitted", color: "#FFA500" },
  { label: "Request Dismissal", value: "req_dismissal", color: "#355C9D" },
  { label: "Overdue", value: "overdue", color: "#808080" },
  { label: "Docs Required", value: "docs_required", color: "#ED7047" },
  { label: "Rejected", value: "rejected", color: "#E62B2A" },
  { label: "Violation Removed", value: "vio_removed", color: "#11B50C" },
];

const StatusChip = ({ status }) => {
  return (
    <div
      className="status-chip"
      style={{ backgroundColor: statusConfig.find(item => item.value === status)?.color || "#808080" }}
    >
      {statusConfig.find(item => item.value === status)?.label || status}
    </div>
  );
};

export default StatusChip; 